/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import {
  Dialog,
  DialogTitle ,
  DialogContent,
  DialogActions
} from "@mui/material";
import {
  StyledListItem,
  StyledOption
} from "../../pages/dashboard/mobile_filters/filters/styles";
import { 
  StyledRadioButton,
  StyledUpdateButton,
} from "./styles";
import { LoadingSpinner } from "../loading_spinner";
import { ModalCancelButton } from "../modal_cancel_button/index";

export const DiscountClassificationModal = ({
  open,
  handleClose,
  selectedAction,
  setSelectedAction,
  onUpdate,
  statusLoading,
  actions,
  title = 'Perq Classification'
}) => {

  return (
    <Dialog
      data-testid='classification-modal'
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      {/* Dialog title */}
      <DialogTitle sx={{textAlign: 'center'}}>
        {title}
      </DialogTitle>

      {/* Dialog Body */}
      <DialogContent>
        {
          actions.map((action) => (
            <StyledListItem
              key={action.value}
              onClick={() => setSelectedAction(action.value)}
            >
              <StyledOption>{action.label}</StyledOption>
              <StyledRadioButton
                data-testid='radio-option'
                checked={selectedAction === action.value}
              />
            </StyledListItem>
           )
          )
        }
      </DialogContent>

      {/* Dialog Actions */}
      <DialogActions sx={{justifyContent: 'center', gap: '10px'}}>
        <ModalCancelButton
          data-testid='modal-cancel-btn'
          disableRipple
          onClick={handleClose}
        >
          Cancel
        </ModalCancelButton>
        <StyledUpdateButton
          data-testid='modal-update-btn'
          disableRipple
          variant="contained"
          onClick={onUpdate}
          disabled={!selectedAction || statusLoading}
        >
          { statusLoading ? <LoadingSpinner isLoading={true} /> : 'Update'}
        </StyledUpdateButton>
      </DialogActions>
    </Dialog>
  )
}
